import { render, staticRenderFns } from "./TabWrapper.vue?vue&type=template&id=30a3168e&scoped=true&"
import script from "./TabWrapper.vue?vue&type=script&lang=js&"
export * from "./TabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TabWrapper.vue?vue&type=style&index=0&id=30a3168e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a3168e",
  null
  
)

export default component.exports